export enum UserRole {
    Readonly = "Readonly",
    Admin = "Admin"
}